import React from 'react';
import { SvgIcon } from '@mui/material';

function AddressBookIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 102 112">
      <path
        d="M7.17988 88.0599C8.00988 89.1099 11.0499 89.3699 11.6299 88.0599C12.4099 86.2899 10.4099 85.8299 9.21988 85.2399C6.69988 83.9799 3.95988 82.0799 4.90988 78.7099C6.60988 72.6899 17.1399 72.8099 21.3999 75.4199C22.3599 76.0099 23.4299 76.8099 24.2399 77.5699C20.2199 80.6899 24.2699 86.3699 28.8599 84.6499C33.3999 82.9199 31.7499 73.8299 26.8399 76.4399C23.2899 69.1999 14.4799 69.7399 10.6899 70.4999C5.64988 71.5099 -1.41012 76.2299 0.909877 82.3799C2.08988 85.4999 4.77987 87.9399 8.08987 88.2299"
        fill="currentColor"
      />
      <path
        d="M7.17988 58.07C8.00988 59.12 11.0499 59.38 11.6299 58.07C12.4099 56.3 10.4099 55.84 9.21988 55.25C6.69988 54.03 3.95988 52.13 4.90988 48.72C6.60988 42.74 17.1399 42.82 21.3999 45.43C22.3599 46.02 23.4299 46.86 24.2399 47.62C20.2199 50.69 24.2699 56.38 28.8599 54.65C33.3999 52.92 31.7499 43.83 26.8399 46.48C23.2899 39.24 14.4799 39.78 10.6899 40.54C5.64988 41.55 -1.41012 46.23 0.909877 52.42C2.08988 55.54 4.77987 57.94 8.08987 58.23"
        fill="currentColor"
      />
      <path
        d="M7.70015 30.7399C8.53015 31.8399 11.5702 32.0899 12.1502 30.7399C12.9302 28.9699 10.9301 28.5499 9.74015 27.9199C7.22015 26.6999 4.48015 24.7999 5.43015 21.4299C7.13015 15.4099 17.6601 15.5299 21.9201 18.0999C22.8801 18.6899 23.9502 19.5299 24.7602 20.2899C20.7202 23.4099 24.7702 29.0899 29.3702 27.3699C33.9102 25.6399 32.2601 16.5499 27.3501 19.1599C23.8101 11.9199 15.0001 12.4599 11.2001 13.2199C6.17015 14.2299 -0.899851 18.9499 1.42015 25.0999C2.60015 28.2199 5.29015 30.6599 8.60015 30.9499"
        fill="currentColor"
      />
      <path
        d="M73.8501 36.8C73.8501 29.18 67.6901 22.98 60.1101 22.98C52.5301 22.98 46.3701 29.17 46.3701 36.8C46.3701 44.43 52.5301 50.62 60.1101 50.62C67.6901 50.62 73.8501 44.43 73.8501 36.8ZM49.5301 36.8C49.5301 30.95 54.2701 26.19 60.0901 26.19C65.9101 26.19 70.6501 30.95 70.6501 36.8C70.6501 42.65 65.9101 47.41 60.0901 47.41C54.2701 47.41 49.5301 42.65 49.5301 36.8Z"
        fill="currentColor"
      />
      <path
        d="M38.5 72.7699V75.3799H81.4V72.1799C81.4 60.4699 71.91 50.9099 60.24 50.9099C48.57 50.9099 38.51 60.7199 38.51 72.7699H38.5ZM60.23 54.1099C70.13 54.1099 78.2 62.2399 78.2 72.1799H41.67C41.99 62.1999 50.26 54.1099 60.21 54.1099H60.23Z"
        fill="currentColor"
      />
      <path
        d="M17.9402 66.5H18.3102V47.72H17.9302C16.3902 47.68 14.9502 47.89 14.0302 48.1L13.7202 48.18V67.39L14.2202 67.22C15.5302 66.8 16.7702 66.55 17.9302 66.5H17.9402Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9602 36.7199L18.3102 36.6799V18.6499H17.8802C16.3202 18.6499 14.9402 18.8599 14.0602 18.9899L13.7402 19.0699V37.7299L14.2402 37.5599C15.5202 37.0999 16.7802 36.7999 17.9502 36.7199H17.9602Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M83.6602 0.879883H31.6302C25.0302 0.879883 18.9902 4.49988 15.8602 10.3999L15.4902 11.0699L16.2702 10.9399C17.9202 10.6399 19.4302 10.5999 20.7802 10.8099H20.9902L21.1302 10.6399C23.6802 7.35988 27.5202 5.45988 31.6402 5.45988H83.6702C91.0202 5.45988 96.9802 11.4399 96.9802 18.8099V85.5299C96.9802 92.8999 91.0002 98.8799 83.6702 98.8799H31.6302C24.2802 98.8799 18.3002 92.8999 18.3002 85.5299V77.5299H17.9302C16.3702 77.3999 14.9302 77.6099 14.0302 77.7799L13.7202 77.8599V85.5299C13.7202 90.7499 16.0002 95.7199 19.9702 99.1799C22.4802 105.96 28.3302 111.12 34.9102 111.12H81.7402C88.9702 111.12 95.3602 104.91 97.2802 97.1599C100.03 93.9199 101.55 89.7899 101.55 85.5399V18.8699C101.55 8.96988 93.5302 0.889881 83.6502 0.889881L83.6602 0.879883ZM89.4702 102.55C87.3202 104.61 84.5802 106.57 81.7502 106.57H34.9202C32.3502 106.57 29.8902 104.82 27.8302 103.14C29.0802 103.39 30.3502 103.56 31.6302 103.56H83.6602C85.6502 103.56 87.5902 103.22 89.4702 102.55Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  );
}

export default AddressBookIcon;
